const tabs = [
  { title: "Analytics", name: "analytics" },
  { title: "Calendar view", name: "calendar" },
  { title: "Marketing", name: "marketing" },
  { title: "Pricing", name: "pricing" },
  { title: "Brand Assets", name: "brand-assets" },
  { title: "Settings", name: "settings" },
];

function TabItem({ title, isActive, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap px-5 py-2 rounded-full hover:bg-surface-primary/50 ${
        isActive ? "!bg-surface-primary shadow-soft" : ""
      } justify-start items-center flex text-content-primary leading-[16.80px] text-sm font-medium`}
    >
      {title}
    </button>
  );
}

export function Tabs({
  activeTab,
  setActiveTab,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}) {
  return (
    <div className="mb-6 w-[calc(100vw-2rem)] overflow-auto md:w-fit p-1 bg-surface-secondary border border-border-primary rounded-[40px] justify-start items-start gap-1 flex">
      {tabs.map((tab) => (
        <TabItem
          key={tab.name}
          title={tab.title}
          isActive={tab.name === activeTab}
          onClick={() => setActiveTab(tab.name)}
        />
      ))}
    </div>
  );
}
